import { createFileRoute } from "@tanstack/react-router";
import SaintScreener from "@/pages/screener/SaintScreener";
export const Route = createFileRoute("/am-i-a-candidate-screener")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Am I A Candidate Screener | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Take our free SAINT TMS candidacy screener. Answer a few questions to see if fMRI-guided accelerated TMS may be right for your depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Am I A Candidate Screener | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Take our free SAINT TMS candidacy screener. Answer a few questions to see if fMRI-guided accelerated TMS may be right for your depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/am-i-a-candidate-screener",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/am-i-a-candidate-screener",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintScreener />;
}
